module.exports = __webpack_public_path__ + "img/list_CommIllustration_06.9d05bfbb.jpeg";